import CardHeader from "components/CardHeader";
import { Invoice } from "models/Invoice";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import * as api from "services/Api";
import { useOfficeTranslation } from "i18n/OfficeTranslation";

const AccountQuotesCard: React.FC<{ accountId: string }> = ({ accountId }) => {
    const { intlLocale, t } = useOfficeTranslation();
    const [quotes, setQuotes] = useState<Invoice[]>([]);

    useEffect(() => {
        api.getInvoices().then(items =>
            setQuotes((items ?? []).filter(invoice => invoice.customer === accountId && invoice.quote))
        );
    }, [accountId]);

    return <Card>
        <CardBody>
            <CardHeader title={t("common.quotes")} icon="mdi-file-certificate-outline" count={quotes.length} />
            {quotes.map(quote => <div className="d-flex justify-content-between align-items-center gap-3 border-bottom py-3" key={quote.id}>
                <div className="min-w-0">
                    <Link to={`/invoice/${quote.id}`} className="fw-semibold text-truncate d-block">
                        {quote.name || quote.id}
                    </Link>
                    <small className="text-muted">{quote.GetCreatedDate().toLocaleDateString(intlLocale)}</small>
                </div>
                <div className="text-end flex-shrink-0">
                    <div>€ {quote.CalcGrandTotal().toFixed(2)}</div>
                    <small className={quote.draft ? "text-muted" : "text-success"}>{t(quote.draft ? "common.status.draft" : "common.status.sent")}</small>
                </div>
            </div>)}
            {!quotes.length && <p className="text-muted mt-3 mb-0">{t("accounts.accountQuotesCard.noQuotesLinkedToThisAccount")}</p>}
        </CardBody>
    </Card>;
};

export default AccountQuotesCard;
